import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  Paper,
  Box,
} from "@material-ui/core";
import Loader from "../../shared/Loader";
import { useAppContext } from "../../../api/AppContext";
import { getFieldProps } from "../../utils";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  selectedMenuItem: {
    backgroundColor: "yellow !important",
  },
});

const Requirements = ({ formik }) => {
  const { fetchConfigurations, configurations, isConfigurationsLoading } =
    useAppContext();
  const { fetchJourneys, journeys, isJourneysLoading } = useAppContext();
  const { fetchListofusers, listofusers, isListofusersLoading } =
    useAppContext();
  const { fetchListofusersContent } = useAppContext();
  const classes = useStyles();

  useEffect(() => {
    fetchConfigurations();
    fetchJourneys();
    fetchListofusers();
  }, [fetchConfigurations, fetchJourneys, fetchListofusers]);

  // Auto-preselect single available options for CID
  useEffect(() => {
    if (
      !isConfigurationsLoading &&
      configurations.length === 1 &&
      (!formik.values.conditions.cid ||
        formik.values.conditions.cid.length === 0)
    ) {
      formik.setFieldValue("conditions.cid", [configurations[0].cid]);
    }
  }, [configurations, isConfigurationsLoading, formik]);

  // Auto-preselect single available options for Journey
  useEffect(() => {
    if (
      !isJourneysLoading &&
      journeys.length === 1 &&
      (!formik.values.conditions.journey ||
        formik.values.conditions.journey.length === 0)
    ) {
      formik.setFieldValue("conditions.journey", [journeys[0].id]);
    }
  }, [journeys, isJourneysLoading, formik]);

  if (isJourneysLoading || isConfigurationsLoading || isListofusersLoading) {
    return <Loader />;
  }

  const selectedCidNames =
    formik.values.conditions.cid?.map((cid) => {
      const config = configurations.find((c) => c.cid === cid);
      return config ? config.name : cid;
    }) || [];

  const selectedJourneyNames =
    formik.values.conditions.journey?.map((journeyId) => {
      const journey = journeys.find((j) => j.id === journeyId);
      return journey ? journey.internalName || journey.name : journeyId;
    }) || [];

  return (
    <Grid container item xs={12}>
      <Grid item>
        <Typography variant="h6">
          In this section you will need to select the news requirements
        </Typography>
      </Grid>
      <Grid container item spacing={2} style={{ marginTop: "1rem" }}>
        <Grid
          container
          item
          spacing={2}
          style={{ justifyContent: "space-around" }}
          xs={12}
        >
          <Grid item xs={4}>
            <TextField
              fullWidth
              label="CID"
              {...getFieldProps(formik, { name: "conditions.cid" })}
              select
              SelectProps={{
                multiple: true,
                onChange: (event) => {
                  formik.setFieldValue("conditions.cid", event.target.value);
                },
                value: formik.values.conditions.cid || [],
              }}
            >
              {configurations
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((configuration) => (
                  <MenuItem
                    key={configuration.cid}
                    className={
                      formik.values.conditions.cid.includes(configuration.cid)
                        ? classes.selectedMenuItem
                        : ""
                    }
                    value={configuration.cid}
                  >
                    {configuration.name}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>

          <Grid item xs={4}>
            <TextField
              fullWidth
              label="Journey"
              {...getFieldProps(formik, { name: "conditions.journey" })}
              select
              SelectProps={{
                multiple: true,
                onChange: (event) => {
                  formik.setFieldValue(
                    "conditions.journey",
                    event.target.value
                  );
                },
                value: formik.values.conditions.journey || [],
              }}
            >
              {journeys
                .sort((a, b) =>
                  (a.internalName || a.name).localeCompare(
                    b.internalName || b.name
                  )
                )
                .map((journey) => (
                  <MenuItem
                    key={journey.id}
                    className={
                      formik.values.conditions.journey.includes(journey.id)
                        ? classes.selectedMenuItem
                        : ""
                    }
                    value={journey.id}
                  >
                    {journey.internalName || journey.name}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
        </Grid>

        <Grid
          container
          item
          spacing={2}
          style={{ justifyContent: "space-around", marginTop: "1rem" }}
          xs={12}
        >
          <Grid item xs={4}>
            <Paper
              style={{
                backgroundColor: "#f5f5f5",
                height: "100%",
                padding: "12px",
              }}
            >
              <Typography
                gutterBottom
                color="textSecondary"
                variant="subtitle2"
              >
                Selected CIDs:
              </Typography>
              <Box>
                {selectedCidNames.length > 0 ? (
                  selectedCidNames.map((name, index) => (
                    <Typography
                      key={index}
                      style={{ marginBottom: "4px" }}
                      variant="body2"
                    >
                      • {name}
                    </Typography>
                  ))
                ) : (
                  <Typography color="textSecondary" variant="body2">
                    No CIDs selected
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={4}>
            <Paper
              style={{
                backgroundColor: "#f5f5f5",
                height: "100%",
                padding: "12px",
              }}
            >
              <Typography
                gutterBottom
                color="textSecondary"
                variant="subtitle2"
              >
                Selected Journeys:
              </Typography>
              <Box>
                {selectedJourneyNames.length > 0 ? (
                  selectedJourneyNames.map((name, index) => (
                    <Typography
                      key={index}
                      style={{ marginBottom: "4px" }}
                      variant="body2"
                    >
                      • {name}
                    </Typography>
                  ))
                ) : (
                  <Typography color="textSecondary" variant="body2">
                    No journeys selected
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
        <Grid
          container
          item
          justifyContent="center"
          style={{ marginTop: "2.5rem" }}
          xs={12}
        >
          <Grid item md={6} xs={10}>
            <TextField
              fullWidth
              select
              SelectProps={{
                multiple: true,
                onChange: async (event) => {
                  const selectedIds = event.target.value || [];
                  formik.setFieldValue("conditions.show_lists", selectedIds);
                  formik.setFieldTouched("conditions.show_lists", true);
                  try {
                    const results = await Promise.all(
                      selectedIds.map((id) =>
                        fetchListofusersContent("", id, false, {
                          forNews: true,
                        })
                      )
                    );
                    const dids = Array.from(
                      new Set(
                        results.flatMap((res) =>
                          Array.isArray(res?.fulldata)
                            ? res.fulldata
                                .map((row) => row?.DID)
                                .filter(
                                  (v) => typeof v === "string" && v.length > 0
                                )
                            : []
                        )
                      )
                    );
                    formik.setFieldValue("conditions.show_dids", dids);
                  } catch (e) {
                    // fail silently
                  }
                },
                value: formik.values.conditions.show_lists || [],
              }}
              helperText="Select lists to show news to those users"
              label="Show news to users in lists"
            >
              {Array.isArray(listofusers)
                ? listofusers
                    .sort((a, b) => a.listname.localeCompare(b.listname))
                    .map((list) => (
                      <MenuItem
                        key={list.id}
                        className={
                          (formik.values.conditions.show_lists || []).includes(
                            list.id
                          )
                            ? classes.selectedMenuItem
                            : ""
                        }
                        value={list.id}
                      >
                        {list.listname}
                      </MenuItem>
                    ))
                : null}
            </TextField>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Requirements;
